<ng-container *transloco="let t">
  <section *ngIf="products?.length > 0">
    <div *ngIf="!hasLicense; else noLicense" class="mb-5">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let product of products">
          <ng-template carouselSlide [width]="375.33">
            <div class="d-flex">
              <app-product-card
                *ngIf="hasLicense ? product.isVisible : product.shouldPromote"
                [hasLicense]="hasLicense"
                [product]="product"
              ></app-product-card>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
    <ng-template #noLicense>
      <div class="d-flex flex-wrap gap-4">
        <ng-container *ngFor="let product of products">
          <app-product-card
            class="card-color w-100"
            *ngIf="hasLicense ? product.isVisible : product.shouldPromote"
            [hasLicense]="hasLicense"
            [product]="product"
            [style]="{ '--border-color': product.color }"
          ></app-product-card>
        </ng-container>
      </div>
    </ng-template>
  </section>
</ng-container>
